import React from 'react';

const ConversationLengthSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='30'
      height='31'
      viewBox='0 0 30 31'
      fill='none'
      onClick={onClick}
      className={className}
      {...props}
    >
      <rect y='0.921875' width='30' height='30' rx='4' fill='#DFF4FF' />
      <path
        d='M14.667 11.5886V15.5886L17.167 18.0886'
        stroke='#0744E1'
        strokeWidth='1.4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.66699 15.5886C4.66699 10.8745 4.66699 8.51749 6.13146 7.05303C7.59592 5.58856 9.95294 5.58856 14.667 5.58856C19.381 5.58856 21.7381 5.58856 23.2025 7.05303C24.667 8.51749 24.667 10.8745 24.667 15.5886C24.667 20.3026 24.667 22.6597 23.2025 24.1241C21.7381 25.5886 19.381 25.5886 14.667 25.5886C9.95294 25.5886 7.59592 25.5886 6.13146 24.1241C4.66699 22.6597 4.66699 20.3026 4.66699 15.5886Z'
        stroke='#0744E1'
        strokeWidth='1.4'
      />
    </svg>
  );
};

export default ConversationLengthSVG;
